import React from 'react';
import { SecureRoute } from '@okta/okta-react';

const Home = React.lazy(() => import('./Home'));

const HomeRoutes = (): React.ReactNode[] => [<SecureRoute key="root" path="/" component={Home} />];

export default HomeRoutes;
